// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { getDefaultSlots } from '@progress/kendo-vue-common';
/** @hidden */
var SchedulerResourceIteratorContextVue2 = {
  name: 'KendoSchedulerResourceIteratorContext',
  inheritAttrs: false,
  props: {
    noWrap: Boolean,
    resource: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    groupIndex: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      ri: {
        resource: this.resource,
        groupIndex: this.groupIndex
      }
    };
  },
  provide: function provide() {
    return {
      ri: this.ri
    };
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return defaultSlot ? this.$props.noWrap && defaultSlot ? defaultSlot[0] : h("div", {
      "class": "k-scheduler-cell k-group-cell"
    }, [defaultSlot]) : null;
  }
};
/** @hidden */
var SchedulerResourceIteratorContext = SchedulerResourceIteratorContextVue2;
export { SchedulerResourceIteratorContext, SchedulerResourceIteratorContextVue2 };